import { createSlice } from "@reduxjs/toolkit";
import {  getSocialMediaList } from "./ThunkAction";
import { iSocialMediaState, REDUCER_NAME } from "./Types";

// Define initial state based on the provided structure
const initialState: iSocialMediaState = {
  isLoading: false,
  socialMediaList: [],
  errorMessage: null,
};

export const socialMediaSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetSocialMediaState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSocialMediaList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSocialMediaList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.socialMediaList = payload.data.data;
          state.isLoading = false;
        }
      })
      .addCase(getSocialMediaList.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch Logo data";
        state.isLoading = false;
      });
  },
});

export const { resetSocialMediaState } = socialMediaSlice.actions;
export default socialMediaSlice.reducer;
